import Axios from 'axios';

Axios.defaults.xsrfCookieName = 'csrftoken';
Axios.defaults.xsrfHeaderName = 'X-CSRFToken';
Axios.defaults.headers.common['X-Accept'] = 'application/json';

export default class PromoteService {
  baseUrl = '/api/v3/pressrelease-checkout';

  promoteEndpoint = 'promote';

  constructor(checkoutToken) {
    this.checkoutToken = checkoutToken;
  }

  async getSitesList() {
    const url = `${this.baseUrl}/${this.checkoutToken}/${this.promoteEndpoint}/`;
    const response = await Axios.get(url);
    return response.data;
  }

  /* eslint-disable camelcase */
  async updateSitesList(crosspost_sites, topic_newsletter_add_ons) {
    const url = `${this.baseUrl}/${this.checkoutToken}/${this.promoteEndpoint}/`;
    const data = { crosspost_sites, topic_newsletter_add_ons };
    const response = await Axios.patch(url, data);
    return response.data;
  }
  /* eslint-enable camelcase */
}
